import {
  Component,
  computed,
  inject,
  input,
  OnInit,
  PendingTasks,
  signal,
} from '@angular/core';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { NodeProfle, Rating } from '@app/models/entity.model';
import { ProductDamageExamplesComponent } from '@app/components/product/product-damage-examples/product-damage-examples.component';
import { ParagraphLoaderComponent } from '@app/entities/paragraph/loader.component';

import { ProductHeroComponent } from '@app/components/product/product-hero/product-hero.component';
import { ProductInShortComponent } from '@app/components/product/product-in-short/product-in-short.component';
import { ProductHowToProceedComponent } from '@app/components/product/product-how-to-proceed/product-how-to-proceed.component';
import { ContentLinkService } from '@app/services/contentLinks.service';
import { MobiLdSchemaComponent } from '@app/components/mobi-ld-schema/mobi-ld-schema.component';
import { CalcCtaPipe } from '@app/pipes/calc-cta.pipe';
import { DataService } from '@app/services/data.service';

@Component({
  selector: 'mobi-node-profle',
  templateUrl: './node-profle.component.html',
  styleUrls: ['./node-profle.component.scss'],
  standalone: true,
  imports: [
    EntitySharedModule,
    ProductDamageExamplesComponent,
    ProductHeroComponent,
    ProductInShortComponent,
    ProductHowToProceedComponent,
    MobiLdSchemaComponent,
    CalcCtaPipe,
    ParagraphLoaderComponent,
  ],
})
export class NodeProfleComponent implements OnInit {
  readonly entity = input.required<NodeProfle>();

  #contentLink = inject(ContentLinkService);
  rating = signal<Rating>({ average_rating: 0, count: 0, ratingPageUrl: undefined });
  #data = inject(DataService);
  #task = inject(PendingTasks);
  isLoading = signal(false);

  async ngOnInit() {
    const cleanup = this.#task.add();

    if (this.entity().productRatingPage?.product?.id) {
      try {
        this.isLoading.set(true);
        const rating: any = await this.#data.getProductRating(
          this.entity().productRatingPage.product.id
        );
        if (!rating || rating.count === 0) {
          this.rating.set({ average_rating: 0, count: 0 });
        } else {
          rating.ratingPageUrl = this.entity().productRatingPage.url.path;
          this.rating.set(rating);
        }
      } catch (error) {
        this.rating.set({ average_rating: 0, count: 0 });
      }
    }

    this.isLoading.set(false);
    cleanup();
  }

  contentLinks = computed(() => {
    const paragraphs = this.entity()?.paragraphs;
    return this.#contentLink.getContentLinks(paragraphs);
  });
}
